import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatNumber } from "helpers/utils";
import { Bar } from "react-chartjs-2";

import type { DataType } from "../../utils";
import { legendLabelsTransform } from "../PieChart/utils";
import type { BarChartData } from "../utils";
import { tooltipLabelFormat } from "../utils";

/**
 * Bar chart and its config
 */
interface IBarChart {
    /**
     * Data for bar chart
     */
    data: BarChartData;
    /**
     * Data type for Y axis
     */
    dataType: DataType;
}
const BarChart = ({ data, dataType }: IBarChart) => {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                onClick: (e) => {}, // disable on clickable legend
                position: "bottom" as const,
                align: "start" as const,
                labels: {
                    usePointStyle: true,
                    pointStyleWidth: 18,
                    boxHeight: 5,
                    font: {
                        size: 10,
                    },
                    generateLabels: (chart) => legendLabelsTransform(chart, (data.labels as string[]) || []),
                },
            },
            datalabels: {
                anchor: "end",
                align: "top",
                color: "#646464",
                offset: 0,
                font: {
                    size: 10,
                },
                formatter: (value) => {
                    if (value !== undefined)
                        return `${formatNumber(value, undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })}`;
                },
            },
            tooltip: {
                titleFont: { size: 10 },
                bodyFont: { size: 10 },
                callbacks: {
                    title: (context) => context?.label,
                    label: (context) => tooltipLabelFormat(context, dataType).labelLines,
                },
                displayColors: false,
                /**
                 * This filter function fix a chart.js issue. For stacked bar-charts, undefined values (0) displays an empty tooltip
                 * So only show tooltips that shows values
                 */
                filter: (context) => context.raw !== undefined,
            },
        },
        interaction: {
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                },
                ticks: {
                    display: false,
                },
            },
            y: {
                stacked: true,
            },
        },
    };

    return <Bar data={data} options={options as any} plugins={[ChartDataLabels as any]} />;
};

export default BarChart;
